/* Reserve the real visible cookie banner height above the cart checkout. */
(() => {
  let queued = false;
  const sync = () => {
    queued = false;
    const banner = document.getElementById('shopify-pc__banner');
    // Shopify's global policy URL can point at a nonexistent /de path on .nl.
    // Use the current market's native policy route, preserving /fr on Belgium.
    const policyRoot = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
    document.querySelectorAll('#shopify-pc__banner a[href*="/policies/privacy-policy"],#shopify-pc__prefs a[href*="/policies/privacy-policy"]').forEach(link => {
      const href = policyRoot + 'policies/privacy-policy';
      if (link.getAttribute('href') !== href) link.setAttribute('href', href);
    });
    let occupied = 0;
    if (banner) {
      const r = banner.getBoundingClientRect(), s = getComputedStyle(banner);
      if (r.width && r.height && s.display !== 'none' && s.visibility !== 'hidden' && r.bottom >= innerHeight - 2 && r.top < innerHeight) occupied = Math.ceil(innerHeight - Math.max(0, r.top));
    }
    const value = occupied + 'px';
    if (document.documentElement.style.getPropertyValue('--en-consent-bottom') !== value) document.documentElement.style.setProperty('--en-consent-bottom', value);
  };
  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(sync); } };
  new MutationObserver(schedule).observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['class','style','hidden','aria-hidden']});
  window.addEventListener('resize', schedule);
  document.addEventListener('visitorConsentCollected', schedule);
  schedule();
})();
